import Link from "next/link";
import { FC } from "react";

type BackLinkProps = {
  form: {
    id: number;
    title: string;
  };
};

const BackLink: FC<BackLinkProps> = ({ form }) => (
  <Link href={`/database/${form.id}`}>
    <p>←「{form.title}」にもどる</p>
  </Link>
);

export default BackLink;
